import { AccessType } from "../../common/enums/DRCXEnums";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import restService from "../rest-service/RestService";
import { ObjectTagValuesAvailableItem, ObjectTagValuesConfiguration, ObjectTagValuesConfigurations, ObjectTagValuesDefault, ObjectTagValuesDefaultOptions, ObjectTagValuesGridColumnConfiguration, ObjectTagValuesGridColumnTypeEnum, ObjectTagValuesTagGroupConfiguration, ObjectTagValuesTagGroupTagConfiguration, ObjectTagValuesTypeEnum } from "./ConfigurationModels";

// TODO: Verify abort signals ??? Say Huh?
// type TargetObjectType = {
//     objectType: eLynxObjectTypeEnum;
//     objectID: number;
//     targetObjectType: eLynxObjectTypeEnum | undefined;
// };

const ObjectTagValuesDataService = {

    // #region Configuration Methods

    getConfiguration: async function (
        groupID: number,
        configurationID: number,
        signal?: AbortSignal
    ): Promise<ObjectTagValuesConfiguration> {

        const path: string = `/groups/${groupID}/objecttagvalues/configurations/${configurationID}`;

        const response = await restService.get<ObjectTagValuesConfiguration>(
            path,
            signal
        );

        return response.data;
    },

    getConfigurations: async function (
        groupID: number,
        objectType: eLynxObjectTypeEnum,
        objectID: number,
        signal?: AbortSignal
    ): Promise<ObjectTagValuesConfigurations> {

        const path: string = `/groups/${groupID}/objecttagvalues/configurations`;

        const response = await restService.get<ObjectTagValuesConfigurations, {
            objectTypeID: eLynxObjectTypeEnum;
            objectID: number;
        }>(
            path,
            signal,
            {
                objectTypeID: objectType,
                objectID: objectID
            }
        );

        return response.data;
    },

    saveConfiguration: async function (
        groupID: number,
        model: ObjectTagValuesConfiguration,
        signal?: AbortSignal
    ): Promise<ObjectTagValuesConfiguration> {

        const path: string = `/groups/${groupID}/objecttagvalues/configuration`;

        const response = await restService.post<ObjectTagValuesConfiguration, ObjectTagValuesConfiguration>(
            path,
            model,
            signal
        );

        model.id = response.data.id;

        return model;
    },

    deleteConfiguration: async function (
        groupID: number,
        model: ObjectTagValuesConfiguration,
        signal?: AbortSignal
    ): Promise<void> {
        const path: string = `/groups/${groupID}/objecttagvalues/configuration`;

        await restService.delete<ObjectTagValuesConfiguration, null>(path, signal, null, model);
    },

    setDefault: async function (
        model: ObjectTagValuesDefault,
        groupID: number,
        objectType?: eLynxObjectTypeEnum,
        objectID?: number,
        signal?: AbortSignal
    ): Promise<void> {

        const path: string = `/groups/${groupID}/objects/${objectType}/${objectID}/objecttagvalues/default`;

        await restService.put<ObjectTagValuesDefault, void>(path, model, signal);
    },

    getDefaultOptions: async function (
        groupID: number,
        configurationID: number,
        objectType?: eLynxObjectTypeEnum,
        objectID?: number,
        signal?: AbortSignal
    ): Promise<ObjectTagValuesDefaultOptions> {

        const path: string = `/groups/${groupID}/objects/${objectType}/${objectID}/objecttagvalues/defaultoptions`;

        const response = await restService.get<ObjectTagValuesDefaultOptions, {
            configurationID: number;
        }>(path, signal, { configurationID: configurationID });

        return response.data;
    },

    getAvailableItems: async function (
        groupID: number,
        eLynxObjectType: eLynxObjectTypeEnum,
        objectID: number,
        signal?: AbortSignal
    ): Promise<Array<ObjectTagValuesAvailableItem>> {

        const path: string = `/groups/${groupID}/objects/${eLynxObjectType}/${objectID}/objecttagvalues/availableitems`;

        const response = await restService.get<Array<ObjectTagValuesAvailableItem>>(path, signal);

        return response.data;
    },

    createDefaultConfiguration: function (configurationID: number, viewType: ObjectTagValuesTypeEnum): ObjectTagValuesConfiguration {
        const configuration: ObjectTagValuesConfiguration = {
            id: configurationID,
            name: "New View",
            viewType: viewType,
            access: AccessType.Private,
            users: [],
            userPermissions: [],
            tagGroups: this.createDefaultTagGroupConfiguration(),
            gridColumns: this.createDefaultGridColumnConfiguration(),
            internal: false
        };

        return configuration;
    },

    createDefaultTagGroupConfiguration: function (): Array<ObjectTagValuesTagGroupConfiguration> {
        return [{
            name: "New Tag Group",
            tags: new Array<ObjectTagValuesTagGroupTagConfiguration>()
        }];
    },

    createDefaultGridColumnConfiguration: function (): Array<ObjectTagValuesGridColumnConfiguration> {
        return [{
            name: "Tag",
            type: ObjectTagValuesGridColumnTypeEnum.Name
        },
        {
            name: "Data Value",
            type: ObjectTagValuesGridColumnTypeEnum.Value
        },
        {
            name: "Units",
            type: ObjectTagValuesGridColumnTypeEnum.Units
        },
        {
            name: "Timestamp",
            type: ObjectTagValuesGridColumnTypeEnum.Timestamp
        }]
    }

    // #endregion Configuration Methods
};

export default ObjectTagValuesDataService;